export default "__VITE_ASSET__372c751e__"